import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col d-flex justify-content-between align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_9 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_10 = { style: {"color":"#848696"} }
const _hoisted_11 = /*#__PURE__*/_createVNode("button", { class: "btn btn-sm btn-info" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "col-lg-4 col-md-12" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_CardBase = _resolveComponent("CardBase")
  const _component_Column = _resolveComponent("Column")
  const _component_router_link = _resolveComponent("router-link")
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_CardBase, {
      allowBack: false,
      title: "System Configuration"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.configs, (config) => {
              return (_openBlock(), _createBlock("div", {
                class: "row",
                key: config.id
              }, [
                _createVNode("div", _hoisted_3, [
                  _createVNode("b", null, _toDisplayString(_ctx.separeteByCapital(config.concept)), 1),
                  _createVNode(_component_InputSwitch, {
                    onChange: ($event: any) => (_ctx.changeConfig(config)),
                    modelValue: config.isActive,
                    "onUpdate:modelValue": ($event: any) => (config.isActive = $event)
                  }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                ]),
                _hoisted_4
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_CardBase, {
      allowBack: false,
      title: "Sign ups"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_DataTable, {
              class: "table-striped p-datatable-sm",
              value: _ctx.filteredItems,
              paginator: true,
              rows: 10,
              rowsPerPageOptions: [10, 20, 50],
              autoLayout: true,
              paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
              currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
            }, {
              header: _withCtx(() => [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Search...",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mainSearch = $event))
                }, null, 512), [
                  [_vModelText, _ctx.mainSearch]
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "id",
                  header: "#"
                }),
                _createVNode(_component_Column, {
                  field: "userId",
                  header: "User ID"
                }, {
                  body: _withCtx((slotProps) => [
                    (slotProps.data.userType === 2)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                  name: slotProps.data.userInfo.corporate
                    ? 'dashboard.company-verify'
                    : 'dashboard.user-verify',
                  params: { id: slotProps.data.userId }
                }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(slotProps.data.userId), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(slotProps.data.userId), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "User Type" }, {
                  body: _withCtx((slotProps) => [
                    (slotProps.data.userType === 1)
                      ? (_openBlock(), _createBlock("span", _hoisted_8, " ADMIN "))
                      : (_openBlock(), _createBlock("span", _hoisted_9, " CUSTOMER "))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "loginDate",
                  header: "Date"
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.date)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "ip",
                  header: "IP"
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("code", _hoisted_10, _toDisplayString(slotProps.data.ip), 1),
                    _createVNode(_component_CopyToClipboard, {
                      text: slotProps.data.ip
                    }, null, 8, ["text"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Actions" }, {
                  body: _withCtx((slotProps) => [
                    (slotProps.data.userType === 2)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                  name: slotProps.data.userInfo.corporate
                    ? 'dashboard.company-verify'
                    : 'dashboard.user-verify',
                  params: { id: slotProps.data.userId }
                }
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _hoisted_12
        ])
      ]),
      _: 1
    })
  ], 64))
}